import React, { Component } from 'react';
import './Styles/Homepage.css';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import { useParams,useNavigate  } from "react-router-dom";
var sha256 = require('js-sha256');



const Login = ({email,password}) => {


    let navigate = useNavigate();
    return (<LoadingButton
        size="big"
        onClick={()=>{
            // this.setState({loading:!this.state.loading})
            console.log(email);
                const postBody = {
                    email: email,
                    password: password
                };
                
                const requestMetadata = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(postBody)
                };
                fetch("http://sfoadmin.myimpactmeter.com:5050/ma/log",requestMetadata)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    if(result['message'] === "Internal Server Error" || result['message'] ===  'Error'){
                        var mainbottom = document.getElementsByClassName("alert-ep");
                        mainbottom[0].style.display = "flex";
                    }
                    else{
                        sessionStorage.setItem("name", result['name']);
                        sessionStorage.setItem("level", result['level']);
                        console.log(result['level'])
                        sessionStorage.setItem("authkey", result['secret']);
                        sessionStorage.setItem("id", result['id']);

                        navigate('dashboard');
                        // this.props.history.push("/dashboard", result);
                    }
                },
                (error) => {
                    
                }
            )
            // this.setState({loading:!this.state.loading})
        }}
        loading={false}
        loadingPosition="end"
        variant="contained"
        sx={{ color:'#ffffff', border:'#ffffff' ,width: '100%' }}
    >
     Login
    </LoadingButton>);
    // sha256('Message to hash');
    
}

export class Homepage extends Component {

    constructor(props) {
        super(props);
        this.state = { loading: false, email:"", password:""};
    }

    myPassword = (event) => {
        this.setState({password: event.target.value});
    }
    myEmail = (event) => {
        this.setState({email: event.target.value});
    }



  render() {
    
    return (
      <div className='hmp'>
            <div className='hmp-lc'>
                <h1 className='hmp-mtxt'> M!M </h1>
                <p className='hmp-stxt'> ADMIN PORTAL </p>
            </div>
            <div className='hmp-rc'>

            

            <Container className='hmp-log' maxWidth="100%">
                <Box component="form" className='hmp-box' sx={{ bgcolor: '#ffffff70' }} autoComplete="off">
                    <Alert className='alert-ep' style={{'display':'none'}} onClose={() => {
                        var mainbottom = document.getElementsByClassName("alert-ep");
                        mainbottom[0].style.display = "none";
                    }} severity="error">Wrong Email or Password</Alert>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <TextField 
                    id="outlined-basic" 
                    label="Email" 
                    variant="outlined"
                    onChange={this.myEmail}
                    value={this.state.email}  
                    sx={{ color:'#ffffff', border:'#ffffff' ,width: '100%' }} />
                    <br></br>
                    <br></br>
                    <TextField
                    id="outlined-password-input"
                    label="Password"
                    type="password"
                    autoComplete="current-password"
                    onChange={this.myPassword}
                    value={this.state.password}
                    sx={{ color:'#ffffff', border:'#ffffff' ,width: '100%' }}
                    />
                    <br></br>
                    <br></br>
                    <Login  email = {this.state.email} password = {this.state.password}/>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                </Box>
                
            </Container>

            

            </div>
      </div>
    );
  }
}

export default Homepage